import { Button } from '@/components/ui';
import { acceptAll, rejectAll } from '@/lib/consent';
import { COOKIE_POLICY_HREF } from './links';

export interface CookieBannerProps {
  /** O navegador envia o Global Privacy Control: o aviso diz que foi respeitado. */
  gpc: boolean;
  onCustomize: () => void;
}

/**
 * A pergunta, quando o site usa uma categoria opcional e ainda não há escolha.
 * Barra inferior que não bloqueia a página, com as três saídas no MESMO peso
 * visual: aceitar não é mais fácil que recusar, e não há "X" que valha aceite.
 */
export function CookieBanner({ gpc, onCustomize }: CookieBannerProps): JSX.Element {
  return (
    <div className="cookie-banner" role="region" aria-label="Aviso de cookies">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <p className="cookie-banner__title">Cookies</p>
          <p>
            Usamos cookies necessários para o site funcionar e, só com a sua permissão, cookies de
            publicidade do Google para exibir anúncios no blog. Você pode mudar a escolha quando
            quiser em “Preferências de cookies”.{' '}
            <a href={COOKIE_POLICY_HREF} className="cookie-consent__link">
              Política de cookies
            </a>
          </p>
          {gpc && (
            <p className="cookie-banner__gpc">
              Seu navegador envia o sinal Global Privacy Control: a publicidade fica desligada até
              você decidir.
            </p>
          )}
        </div>
        <div className="cookie-banner__actions">
          <Button className="cookie-banner__action" onClick={acceptAll}>
            Aceitar todos
          </Button>
          <Button className="cookie-banner__action" onClick={rejectAll}>
            Rejeitar não essenciais
          </Button>
          <Button className="cookie-banner__action" onClick={onCustomize}>
            Personalizar
          </Button>
        </div>
      </div>
    </div>
  );
}
